<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.discountInformation" | translate }}
          </legend>

          <div class="row">
            <!-- discountType -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="DiscountType"
                [label]="fields + 'discountType'"
                [control]="form?.get('discountType')"
                [(value)]="model.discountType"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- discountCode -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.discountCode"
                [control]="form?.get('discountCode')"
                [label]="fields + 'discountCode' | translate"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- isPercentage -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-flex tw-items-center">
              <mat-slide-toggle
                formControlName="isPercentage"
                [(ngModel)]="model.isPercentage"
                (change)="onChangeIsPercentage()"
              >
                {{ fields + "isPercentage" | translate }}</mat-slide-toggle
              >
            </div>
          </div>

          <div class="row">
            <!-- discountPercentageValue -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4" *ngIf="model.isPercentage">
              <form-field
                class="tw-w-full"
                [label]="fields + 'discountPercentageValue' | translate"
                [control]="form?.get('discountPercentageValue')"
                [(value)]="model.discountValue"
                [maxLength]="5"
                [minLength]="1"
                [min]="0"
                [max]="100"
              >
                <i suffix-content class="mdi mdi-percent mdi-23px"></i>
              </form-field>
            </div>

            <!-- discountValue -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4" *ngIf="!model.isPercentage">
              <form-field
                type="tel"
                [(value)]="model.discountValue"
                [control]="form?.get('discountValue')"
                [label]="fields + 'discountValue' | translate"
                [hasNumberSeparator]="true"
                [hasCurrency]="true"
              >
              </form-field>
            </div>

            <!-- maximumUse -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                type="tel"
                [(value)]="model.maximumUse"
                [control]="form?.get('maximumUse')"
                [label]="fields + 'maximumUse' | translate"
                [hasNumberSeparator]="true"
              >
              </form-field>
            </div>

            <!-- specialOrganization -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <organization-select-search
                type="descendantAndItselfList"
                [label]="fields + 'specialOrganization' | translate"
                [control]="form?.get('specialOrganization')"
                [(value)]="model.specialOrganizationId"
                (onError)="onClose()"
              >
              </organization-select-search>
            </div>

            <!-- maximumAmount -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4" *ngIf="model.isPercentage">
              <form-field
                [(value)]="model.maximumAmount"
                [control]="form?.get('maximumAmount')"
                [min]="1"
                [label]="fields + 'maximumAmount' | translate"
                [hasCurrency]="true"
              >
              </form-field>
            </div>

            <!-- startDateTime & endDateTime -->
            <app-periodic-date-time-picker
              [config]="periodicDateTimeConfig"
              (startDateTime)="model.dateStart = $event"
              (endDateTime)="model.dateExpire = $event"
            >
            </app-periodic-date-time-picker>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
